function idMethod(idNum) {
  try {
    // SA ID Number have to be 13 digits, so check the length
    if (idNum.length !== 13 || isNaN(idNum)) {
      return "error";
    }

    // apply Luhn formula for check-digits
    let initTotal = 0;
    let checkSum = 0;
    let multiplier = 1;
    for (var i = 0; i < 13; ++i) {
      initTotal = parseInt(idNum.charAt(i), 10) * multiplier;
      if (initTotal > 9) {
        initTotal =
          parseInt(initTotal.toString().charAt(0), 10) +
          parseInt(initTotal.toString().charAt(1), 10);
      }
      checkSum = checkSum + initTotal;
      multiplier = multiplier % 2 === 0 ? 1 : 2;
    }

    if (checkSum % 10 !== 0) {
      return "error";
    }

    let year = idNum.substring(0, 2);
    let yDif = (new Date().getFullYear() - 14).toString().substring(2, 4);

    if (parseInt(year, 10) > yDif) {
      year = "19" + year;
    } else {
      year = "20" + year;
    }

    //get date of birth from id
    let initDate = new Date(
      year,
      idNum.substring(2, 4) - 1,
      idNum.substring(4, 6)
    );

    let dob = formattedDate(initDate);

    // get Gender from id number
    let genderCode = idNum.substring(6, 10);
    const gender = parseInt(genderCode, 10) < 5000 ? "F" : "M";
    return {
      gender,
      dob
    };
  } catch (error) {
    console.log(error);
    return "error";
  }
}

function formattedDate(date) {
  var mm = date.getMonth() + 1; // getMonth() is zero-based
  var dd = date.getDate();

  return [
    (dd > 9 ? "" : "0") + dd,
    (mm > 9 ? "" : "0") + mm,
    date.getFullYear()
  ].join("/");
}

const isEmptyOrSpaces = str => {
  return (
    str === undefined || str === null || str.toString().match(/^ *$/) !== null
  );
};

export const idNumberValid = value => {
  if (!value) {
    return undefined;
  }

  if (isEmptyOrSpaces(value)) {
    return undefined;
  }

  if (isNaN(Number(value))) {
    return "Must be a number";
  }

  if (value.length !== 13) {
    return "Id number too short";
  }

  let x = idMethod(value);
  if (x === "error") {
    return "Invalid Id";
  }

  return undefined;
};

export default idMethod;



// WEBPACK FOOTER //
// ./src/helpers/GetIdInformation.js